"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteRequestParams = void 0;
var AuthSuiteRequestParams;
(function (AuthSuiteRequestParams) {
    AuthSuiteRequestParams["ActivationCode"] = "activationCode";
    AuthSuiteRequestParams["FilterType"] = "filterType";
    AuthSuiteRequestParams["LogoSchema"] = "logoSchema";
    AuthSuiteRequestParams["CallbackUrl"] = "callbackUrl";
    AuthSuiteRequestParams["AuthorizationCode"] = "authorizationCode";
    AuthSuiteRequestParams["WaitWithLastKnownStatus"] = "waitWithLastKnownStatus";
    AuthSuiteRequestParams["PromoCode"] = "promoCode";
    AuthSuiteRequestParams["TopProvidersLimit"] = "topProvidersLimit";
})(AuthSuiteRequestParams = exports.AuthSuiteRequestParams || (exports.AuthSuiteRequestParams = {}));
